"use client";

import * as React from "react";

import { useLocalizedInput } from "@/hooks/useLocalizedInput";
import { cn } from "@/lib/utils";

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea"> & { browserOwned?: boolean }
>(
  (
    {
      className,
      onChange,
      onBlur,
      browserOwned,
      value,
      defaultValue,
      onInput,
      onCompositionStart,
      onCompositionEnd,
      ...props
    },
    ref,
  ) => {
    const { valueProps, inputEvents } = useLocalizedInput<HTMLTextAreaElement>({
      ref,
      browserOwned,
      value,
      defaultValue,
      onChange,
      onBlur,
      onInput,
      onCompositionStart,
      onCompositionEnd,
    });
    return (
      <textarea
        className={cn(
          "flex min-h-[60px] w-full rounded-xs border border-stroke-light bg-transparent px-3 py-2 text-base shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className,
        )}
        {...props}
        {...valueProps}
        {...inputEvents}
      />
    );
  },
);
Textarea.displayName = "Textarea";

export { Textarea };
